'use client';

import { c as _c } from "react/compiler-runtime";
import { LiveDataContext } from './LiveDataContext.mjs';
import { useLiveData } from '@/shared/hooks/useLiveData.mjs';
import LiveToasts from '@/features/notifications/LiveToasts';

/**
 * App-wide live data provider. Wraps children with SSE campaign data
 * via React Context so any page can access live state and receive
 * toast notifications.
 *
 * Must be rendered from a client component boundary (not a server
 * component) so that LiveToasts and the Sonner Toaster share the
 * same module singleton.
 *
 * @param {{initialData: object | null, initialMapState: object | null, children: React.ReactNode}} props - Component props
 */
export default function LiveDataProvider(t0) {
  const $ = _c(14);
  const {
    initialData,
    initialMapState,
    children
  } = t0;
  const {
    data,
    mapState,
    status,
    prevData,
    isLeader
  } = useLiveData(initialData, initialMapState);
  let t1;
  if ($[0] !== data || $[1] !== isLeader || $[2] !== mapState || $[3] !== prevData || $[4] !== status) {
    t1 = {
      data,
      mapState,
      status,
      prevData,
      isLeader
    };
    $[0] = data;
    $[1] = isLeader;
    $[2] = mapState;
    $[3] = prevData;
    $[4] = status;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== data || $[7] !== isLeader || $[8] !== prevData) {
    t2 = <LiveToasts prevData={prevData} data={data} isLeader={isLeader} />;
    $[6] = data;
    $[7] = isLeader;
    $[8] = prevData;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== t1 || $[12] !== t2) {
    t3 = <LiveDataContext.Provider value={t1}>{t2}{children}</LiveDataContext.Provider>;
    $[10] = children;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}